<script setup lang="ts">
import { useI18n } from '@/plugins/i18n'
import { useSearchStore } from '../store/index.ts'
import { STANDARDS_SEARCH_TAB, COLLECTIONS_SEARCH_TAB, UPDATES_SEARCH_TAB } from '@/components/Search/constants.ts';
const searchStore = useSearchStore()
const { getItem } = searchStore

//translations
const i18nInstance: any = useI18n()
const { t } = i18nInstance
</script>

<template>
    <div class="search-tabs">
        <div :class="['search-tab', 'standards', { active: getItem('activeTab') === STANDARDS_SEARCH_TAB }]" @click="searchStore.setItem('activeTab', STANDARDS_SEARCH_TAB)">
            {{ t('standards') }}
        </div>
        <div :class="['search-tab', 'collections', { active: getItem('activeTab') === COLLECTIONS_SEARCH_TAB }]" @click="searchStore.setItem('activeTab', COLLECTIONS_SEARCH_TAB)">
            {{ t('collections') }}
        </div>
        <div :class="['search-tab', 'updates', { active: getItem('activeTab') === UPDATES_SEARCH_TAB }]" @click="searchStore.setItem('activeTab', UPDATES_SEARCH_TAB)">
            {{ t('updates') }}
        </div>
    </div>
</template>